import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Divider } from "semantic-ui-react";
import LoadResolver from "components/LoadResolver";
import { toast } from "../Toast/Toast";
import { PrintServiceForm } from "forms/PrintService";
import { getAgencys, getUsers } from "store/selectors";
import { AgencyType } from "models";
import { PrintServiceTable } from "../PrintServiceTable/PrintServiceTable";

export const PrintServiceEditor = ({ dispatch, t }) => {
  const [isPrintServiceFormOpen, setIsPrintServiceFormOpen] = useState(false);
  const [printServiceToUpdate, setPrintServiceToUpdate] = useState(null);

  useEffect(() => {
    dispatch.agencys.load(AgencyType.PRINT_SERVICE);
    dispatch.users.init();
  }, []);

  const agencys = useSelector(getAgencys);
  const users = useSelector(getUsers);

  const handlePrintServiceFormClose = () => {
    setIsPrintServiceFormOpen(false);
    setPrintServiceToUpdate(null);
  };

  const handleUpdate = (printServiceToUpdate) => {
    setPrintServiceToUpdate(printServiceToUpdate);
    setIsPrintServiceFormOpen(true);
  };

  const handleDelete = async (printServiceToDelete) => {
    try {
      await dispatch.agencys.delete(printServiceToDelete.id);
      toast(undefined, t("print_service_delete_success"));
    } catch (error) {
      console.error(error);
      toast("error", t("print_service_delete_failure"));
    }
  };

  return (
    <LoadResolver
      isLoading={agencys.isLoading || users.isLoading}
      error={agencys.error || users.error}
    >
      <div className="page-container">
        <h2>{t("print_services")}</h2>
        {isPrintServiceFormOpen ? (
          <PrintServiceForm
            printServiceToUpdate={printServiceToUpdate}
            closePrintServiceForm={handlePrintServiceFormClose}
            users={users.items}
            dispatch={dispatch}
            t={t}
          />
        ) : (
          <>
            <Button primary onClick={() => setIsPrintServiceFormOpen(true)}>
              {t("create_new")}
            </Button>
            <Divider />
            <PrintServiceTable
              items={agencys.items}
              users={users.items}
              setPrintServiceToUpdate={setPrintServiceToUpdate}
              handleUpdate={handleUpdate}
              handleDelete={handleDelete}
              t={t}
            />
          </>
        )}
      </div>
    </LoadResolver>
  );
};
